import React from "react";
import { RiCake2Fill } from "react-icons/ri";
import { Wrapper, CakeWrapper, Candle, Flame, Ribbon } from "./Cake.styled";

const Cake = () => {
  return (
    <CakeWrapper>
      <Candle>
        <Flame />
      </Candle>
    </CakeWrapper>
  );
};

const CakeComponent = () => {
  return (
    <Wrapper>
      <Ribbon>
        <img src="./ribbon.png" alt="ribbon" />
      </Ribbon>
      <div className="heading">
        <RiCake2Fill />
        <h1>Make a Wish..</h1>
      </div>
      <Cake />
    </Wrapper>
  );
};

export default CakeComponent;
